// extracted by mini-css-extract-plugin
module.exports = {"parceiro":"index-module--parceiro--26bnx","title":"index-module--title--2sUn_","parceiros":"index-module--parceiros--1t9Oo"};